import BaseDataObject from './BaseDataObject';
import Horse from './Horse';
import JockeyTrainer from './JockeyTrainer';
import OriginalJockey from './OriginalJockey';

export default class RaceInformation extends BaseDataObject {
  getBetType() {
    return this.getString('betType');
  }

  getRaces() {
    return this.getObjects('races', Race);
  }

  getRace(index) {
    return this.getObject('races', Race, index);
  }

  getNumberOfRaces() {
    return this.getNumberOf('races');
  }
}

class Race extends BaseDataObject {
  getStarts() {
    return this.getObjects('starts', Start);
  }

  getStart(index) {
    return this.getObject('starts', Start, index);
  }

  getNumberOfStarts() {
    return this.getNumberOf('starts');
  }

  getRaceNumber() {
    return this.getInteger('raceNr');
  }

  getLegNumber() {
    return this.getInteger('legNr');
  }

  getDistance() {
    return this.getInteger('distance');
  }

  getStartMethod() {
    return this.getString('startMethod');
  }

  getTime() {
    return this.getDate('postTime');
  }

  getExternalURL() {
    return IS_SE_SITE
      ? this.getString('atgUrl')
      : this.getString('rikstotoUrl');
  }

  getRaceKey() {
    return this.getString('raceKey');
  }

  getRaceDetails() {
    const string = this.getString('raceDetails') || '';
    return string.trim();
  }

  getIsMonte() {
    return this.getBoolean('isMonte');
  }

  getSlug() {
    return this.getString('slug');
  }
}

class Start extends BaseDataObject {
  getStartNumber() {
    return this.getInteger('startNo');
  }

  getHorse() {
    return this.getObject('horse', Horse);
  }

  getJockey() {
    return this.getObject('driver', JockeyTrainer);
  }

  getTrainer() {
    return this.getObject('trainer', JockeyTrainer);
  }

  getOriginalJockey() {
    return this.getObject('originalDriver', OriginalJockey);
  }
}
